import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bool-rule" }

import MSelect from "@/BasicComponentLibrary/MSelect.vue";
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";

//#region General
type ViewModel = { options: Array<{ text: string; value: number }> };

export default /*#__PURE__*/_defineComponent({
  __name: 'BoolRule',
  props: {
    value: {}
  },
  emits: ["input"],
  setup(__props: any, { emit }) {

const props = __props;



const { t: $t } = useI18n();
//#endregion

//#region ViewModel
const vm = reactive<ViewModel>({
  options: [
    { text: `<${$t("noValue")}>`, value: -1 },
    { text: $t("yes"), value: 1 },
    { text: $t("no"), value: 0 }
  ]
});
//#endregion

//#region LocalModel
const localModel = computed<number>({
  get() {
    switch (props.value) {
      case "true":
        return 1;
      case "false":
        return 0;
      default:
        return -1;
    }
  },
  set(nv) {
    switch (nv) {
      case 1:
        emit("input", "true");
        break;
      case 0:
        emit("input", "false");
        break;
      case -1:
        emit("input", "");
        break;
    }
  }
});
//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MSelect, {
      modelValue: localModel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModel).value = $event)),
      items: vm.options,
      textField: "text",
      valueField: "value"
    }, null, 8, ["modelValue", "items"])
  ]))
}
}

})